<style lang="less">
    @import "../../../styles/table.less";
</style>
<template>
    <div class="search">
        <Row>
            <Col>
                <Card>
                    <!--<Row class="operation">
                        <Button @click="add" type="primary" icon="md-add">新建会员</Button>
                        <Button @click="getDataList" icon="md-refresh">刷新</Button>
                        <circleLoading v-if="operationLoading"/>
                    </Row>
                    <Row>
                        <Alert show-icon>
                            已选择 <span class="select-count">{{selectCount}}</span> 项
                            <a class="select-clear" @click="clearSelectAll">清空</a>
                        </Alert>
                    </Row>-->
                    <Row>
                        <Table :loading="loading" border :columns="columns" :data="data" sortable="custom" @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
        <Modal :title="modalTitle" v-model="modalVisiblePirce" :mask-closable='false' :width="500">
            <Form ref="priceForm" :model="form" :label-width="80" :rules="formValidate">
                <FormItem label="价格名称" prop="priceName">
                    <Input v-model="form.priceName"/>
                </FormItem>
                <FormItem label="安卓原价" prop="androidOldPrice">
                    <InputNumber style="width:100%" :formatter="value  => `¥ ${value }`.replace(/B(?=(d{3})+(?!d))/g, ',')"
                     :parser="value => value.replace(/¥s?|(,*)/g, '')" :min="1" v-model="form.androidOldPrice"></InputNumber>
                </FormItem>
                <FormItem label="安卓现价" prop="androidPrice">
                    <InputNumber style="width:100%" :formatter="value  => `¥ ${value }`.replace(/B(?=(d{3})+(?!d))/g, ',')"
                                 :parser="value => value.replace(/¥s?|(,*)/g, '')" :min="1" v-model="form.androidPrice"></InputNumber>
                </FormItem>
                <FormItem label="时效" prop="vipTime">
                    <InputNumber style="width:100%" v-model="form.vipTime" type="number" placeholder="会员有效期"/>
                </FormItem>
                <FormItem label="排序号" prop="sortOrder">
                    <InputNumber style="width:100%" v-model="form.sortOrder" type="number" placeholder="自定义排序号"/>
                </FormItem>
                <FormItem label="赠送积分" prop="scoreVip">
                    <InputNumber style="width:100%" v-model="form.scoreVip" :max="1000" type="number" placeholder="购买vip赠送积分"/>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" @click="cancel">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="submitVipPrice">提交</Button>
            </div>
        </Modal>
        <vip-type-drawer ref="vipTypeDrawer"></vip-type-drawer>
        <vip-price-drawer ref="vipPriceDrawer"></vip-price-drawer>


    </div>
</template>

<script>
    import circleLoading from "../../my-components/circle-loading.vue";
    import {add, edit, delByIds, get} from "@/api/vipType";
    import {list, update} from "@/api/vipPrice";
    import vipTypeDrawer from "./vipType-drawer";
    import VipPriceDrawer from "./vipPrice-drawer";

    export default {
        name: "viptype-manage",
        components: {
            VipPriceDrawer,
            circleLoading,
            vipTypeDrawer
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                drop: false,
                modalVisiblePirce: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                modalTitle: "价格配置",
                submitLoading: false,
                searchForm: {
                    vipTypeId: 2,
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    studentName: "",
                    mobile: "",
                    startDate: "",
                    endDate: ""
                },
                form: {
                    id: "",
                    vipTypeId: 2,
                    androidPrice: 0,
                    priceName: '',
                    vipTime: 1,
                    androidOldPrice: 0,
                    sortOrder:0,
                    scoreVip: 0
                },
                formValidate: {
                    priceName: [{required: true, message: "名称不能为空", trigger: "blur"}]
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    /*{
                        type: "selection",
                        width: 60,
                        align: "center"
                    },*/
                    {
                        type: "index",
                        title: "序号",
                        width: 80,
                        align: "center"
                    },
                    {
                        title: "vip名称",
                        key: "priceName",
                        align: "center",
                    },
                    {
                        title: "安卓原价",
                        key: "androidOldPrice",
                        align: "center",
                    },
                    {
                        title: "安卓现价",
                        key: "androidPrice",
                        align: "center",
                    },
                    {
                        title: "苹果原价",
                        key: "iosOldPrice",
                        align: "center",
                    },
                    {
                        title: "vip时效",
                        key: "vipTimeA",
                        align: "center",
                    },
                    {
                        title: "苹果现价",
                        key: "iosPrice",
                        align: "center",
                    },
                    {
                        title: "排序号",
                        key: "sortOrder",
                        align: "center",
                    },
                    {
                        title: "赠送积分",
                        key: "scoreVip",
                        align: "center",
                    },
                    {
                        title: "操作",
                        key: "action",
                        width: 200,
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.editPrice(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                                /* h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.setPrice(params.row);
                                            }
                                        }
                                    },
                                    "价格设置"
                                ),
                                h(
                                     "Button",
                                     {
                                         props: {
                                             type: "error",
                                             size: "small"
                                         },
                                         on: {
                                             click: () => {
                                                 this.remove(params.row);
                                             }
                                         }
                                     },
                                     "删除"
                                 )*/
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            init() {
                // this.getTreeData();
                this.getDataList();
            },
            getDataList() {
                this.loading = true;
                list(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
            add() {
                let query = {type: 0}
                this.$refs.vipTypeDrawer.showDrawer(query);
            },
            edit(row) {
                let query = {id: row.id};
                this.$refs.vipTypeDrawer.showDrawer(query);
            },
            editPrice(row) {
                this.modalType = 1;
                this.form.id = row.id,
                this.form.priceName = row.priceName,
                this.form.androidPrice = row.androidPrice,
                this.form.androidOldPrice = row.androidOldPrice,
                this.form.vipTime = row.vipTime,
                this.form.sortOrder = row.sortOrder,
                this.form.scoreVip = row.scoreVip
                this.modalVisiblePirce = true;
            },
            cancel() {
                this.modalVisiblePirce = false;
            },
            submitVipPrice() {
                this.$refs.priceForm.validate(valid => {
                    if (valid) {
                        if(this.form.scoreVip < 0){
                            this.$Message.error("积分不能小于零");
                            return false;
                        }
                        this.submitLoading = true;
                        update(this.form).then(res => {
                            this.submitLoading = false;
                            if (res.status === true) {
                                this.$Message.success("操作成功");
                                this.getDataList();
                                this.modalVisiblePirce = false;
                            }
                        });
                    }
                });
            },
            setPrice(row) {
                let query = {vipTypeId: row.id};
                this.$refs.vipPriceDrawer.showDrawer(query);
            },
            remove(row) {
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除?",
                    onOk: () => {
                        delByIds(row.id).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.getDataList();
                            }
                        });
                    }

                });
            },
            delAll() {

            }
        },
        mounted() {
            this.init();
        }
    }
</script>
